import { useRef } from "react";
import { RocketLaunch } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ExerciseInterface } from "../../interfaces/examInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "../..";
import { addExerciseHeight } from "./Functions/FunctionsCreatePages";
import { ExerciseContainer, BoxNumber, ExerciseNumber, ExerciseImage, ExercisePoints, PointsContainer, PointsTextField, Rocket } from "./Layouts/Legacy/LegacyStyles";

export const MeasureExercise = ({
  exercise,
  imageUrl,
  zoomFactor,
}: {
  exercise: ExerciseInterface;
  imageUrl: string;
  zoomFactor: number;
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const exerciseHeights = useSelector((state: RootState) => state.examBuilder.main.exerciseHeights);
  const id = exercise.id;

  return (
    <>
      <Box ref={containerRef}>
        <ExerciseContainer zoomfactor={zoomFactor}>
          <BoxNumber zoomfactor={zoomFactor}>
            {" "}
            <ExerciseNumber zoomfactor={zoomFactor}>{exercise.index + 1})</ExerciseNumber>
            {exercise.level === 3 && (
              <Rocket zoomfactor={zoomFactor}>
                <RocketLaunch />
              </Rocket>
            )}
          </BoxNumber>

          <ExerciseImage zoomfactor={zoomFactor}>
            <img
              src={imageUrl}
              alt=""
              onLoad={(e) => {
                if (containerRef.current) {
                  const heightData = { id, height: containerRef.current.offsetHeight };
                  addExerciseHeight(exerciseHeights, heightData);
                }
              }}
            />
          </ExerciseImage>
        </ExerciseContainer>
        <ExercisePoints zoomfactor={zoomFactor}>
          <PointsContainer zoomfactor={zoomFactor}>
            /<PointsTextField id="outlined-basic" variant="filled" value={exercise.points} zoomfactor={zoomFactor} />
          </PointsContainer>
        </ExercisePoints>
      </Box>
    </>
  );
};

export default MeasureExercise;
